import React from 'react';

export default function Cancel(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.44 14.44" {...props}>
      <path d="M7.92,7.22,14.29.85a.5.5,0,0,0,0-.7.5.5,0,0,0-.71,0L7.22,6.51.85.15a.48.48,0,0,0-.7,0,.48.48,0,0,0,0,.7L6.51,7.22.15,13.58a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0L7.22,7.92l6.36,6.37a.5.5,0,0,0,.71-.71Z" />
    </svg>
  );
}
